<template>
  <div class="category">
    <div class="heading" @click="handleDropDownClick">
      <h4 class="title">{{ filtername }}</h4>
      <span
        :class="configuration[filtername].expanded ? 'up-arrow' : 'down-arrow'">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="inherit"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.585 8.58496L12 13.17L7.415 8.58496L6 9.99996L12 16L18 9.99996L16.585 8.58496Z"
            fill="inherit" />
        </svg>
      </span>
    </div>
    <div v-if="configuration[filtername].expanded" class="content datepicker">
      <input
        type="number"
        :value="value"
        class="numeric-input"
        :placeholder="`Enter ${filtername}`"
        @input="handleChange" />
    </div>
  </div>
</template>

<script>
import "vue2-datepicker/index.css";

export default {
  name: "NumericFilter",
  props: {
    filtername: {
      type: String,
      required: true,
    },
    configuration: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      default: null,
    },
  },
  methods: {
    handleChange() {
      this.$emit("handleFilterChange", {
        type: "numeric",
        filterName: this.filtername,
        value: event.target.value,
      });
    },
    handleDropDownClick() {
      this.$emit("handleFilterToggle", `${this.filtername}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.numeric-input {
  background-color: var(--search-bar-bg);
  border: 0.0625rem solid var(--label-text);
  border-color: var(--tab-border);
  padding: 6px;
  margin: 10px 0;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  color: var(--primary-text);
}
</style>
